import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import {
    FAILURE_ORDERING_NOTE_SUBJECTS,
    REQUEST_ORDERING_NOTE_SUBJECTS,
    SUCCESS_ORDERING_NOTE_SUBJECTS,
} from './actions';

export function orderingNoteSubjectsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ORDERING_NOTE_SUBJECTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ORDERING_NOTE_SUBJECTS:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_ORDERING_NOTE_SUBJECTS:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
